import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import VerifyStep from './VerifyStep';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class GoToInboxRow extends PureComponent {
  renderButton() {
    const {
      onConfirm
    } = this.props;
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      size: "small",
      onClick: onConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.verifyFbmPrompt.stepTwo.button"
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(VerifyStep, {
      button: this.renderButton(),
      borderBottom: true,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepTwo.header"
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "0",
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepTwo.body"
          })
        })]
      })
    });
  }
}
GoToInboxRow.displayName = 'GoToInboxRow';
export default GoToInboxRow;